import React, { useState, useEffect } from 'react';
import {callback, parseRaspberryRowText, parseNumber} from '../../helpers.js';
import Box from '../ui/Box.js'
import './PieceRateInput.scss';

export default (props) => {

	let errors = [];




	const format = (text) => {
		let t = (text || '').replace(/[^(\s|\n|\,|\$|x|\*|\d?\.?\d+|\n)]/g, '');
		const d = parseRaspberryRowText(t);
		errors = d['errors'];
		return t;
	}
	

	const [text, setText] = useState(format(props.text) || '');
	const [open, setOpen] = useState(false);
	//const [error, setError] = useState([]);

	useEffect(()=>{
		setText(props.text || '');
	}, [props.text]);

/*
	const onChange = (e) => {
		const out = e.target.value;
		if (e.target.name === 'value') {
			setValue(out);
			callback(props.onChange, [{target: {name: props.name, value: convert(out).from(units).to(props.baseUnits)}}]);
		} else {
			setUnits(out);
			callback(props.onChange, [{target: {name: props.name, value: convert(value).from(out).to(props.baseUnits)}}]);
		}
	}*/

	let warn = false;
	const calculate = (str) => {
		//console.log("Calculate is being called on", str);
		
		const d = parseRaspberryRowText(str);
		const pieces = d['data'];
		errors = d['errors'];
		let sum = 0;
		for(let i = 0; i < pieces.length; i++) {
			try {
				const amount = parseNumber(pieces[i][0]);
				const value = parseNumber(pieces[i][1]);
				sum += amount * value;
			} catch (e) {
				warn = true;
			}
		}
		return sum;
	}
	
	const calculated = calculate(props.text);

	const okay = (e) => {
		//console.log("OKAY", text);
		const t = text;
		setText(props.text);
		setOpen(false);
		props.onChange(t, calculate(t));
	}

	const openForm = (e) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();
		}
		setOpen(true);
	}

	const cancel = (e) => {
		setText(props.text);
		setOpen(false);
	}
	
	let errorstr = '';
	if (errors.length > 0) {
		errorstr = <ul className="error">{errors.map((a)=><li>{a}</li>)}</ul>;
	}

	return (
		<div className={(props.className || '') + ' piecerate-input'}>
		<button className={"clear " + (warn ? 'problem' : '')} onClick={openForm}>${(parseFloat(calculated) || 0).moneyFormat()}</button>
		<Box
			modal={true}
			isOpen={open}
			title="Piecerate interface test"
			onRequestClose={cancel}
		>
			<div className="piecerate-input-box">
				<p>Enter the number of rows for each value. <code><strong>2 x $50, $30, 5 x 35</strong></code>. Separate them with a comma or a new line.</p>
				<textarea value={text || ''} onChange={(e)=>setText(format(e.target.value))} />
				{errorstr}
				<button className="block" onClick={okay}>Okay</button>
			</div>
		</Box>
		</div>
	);
}

